import { useState, useEffect, useRef } from 'react';
import { RangeSlider, BlindspotControl } from '..';
import { useCalibration } from '../../context/calibrationContext';
import { calibrationConstants } from '../../helpers/calibration-constants';
import { Flex, Text } from '../../2022-component-library';
import { usePostMessage } from '../../context/messageContext';
import { useMediaQuery } from '../../helpers/useMediaQuery';

const DistanceControlBlindspot = () => {
  const smallScreen = useMediaQuery('(max-width: 1190px)');
  const postMessage = usePostMessage();
  const {
    calibrationData: { circleDimensionsPx, screenWidthPx, distanceFromScreen, pixelDensity },
  } = useCalibration();
  const { blindSpotThumbnailWidthPx, blindSpotThumbnailHeightPx, blindSpotThumbnailY } = calibrationConstants;
  const [blindspotPositionValue, setBlindspotPositionValue] = useState(screenWidthPx / 2 - circleDimensionsPx / 2 || 0);
  const didMountRef = useRef(false);
  const [messageContent, setMessageContent] = useState({});

  const dataFromOptician = {
    blindSpotThumbnailWidthPx: blindSpotThumbnailWidthPx,
    blindSpotThumbnailHeightPx: blindSpotThumbnailHeightPx,
    blindSpotThumbnailY: blindSpotThumbnailY,
    circleDimensionsPx: circleDimensionsPx,
    pixelDensity: pixelDensity,
    screenWidthPx: screenWidthPx,
  };

  const sendVideoCoordinates = (e) => {
    const x = e.target.value;
    const messageContent = {
      type: 'blindSpotVideoXPosition',
      content: {
        clientX: parseInt(x),
        clientY: 250,
        circleDimensionsPx: circleDimensionsPx,
        dataFromOptician: dataFromOptician,
      },
    };
    postMessage(messageContent);
  };

  useEffect(() => {
    if (didMountRef.current) {
      setMessageContent({
        type: 'blindSpotXPosition',
        content: {
          clientX: parseInt(blindspotPositionValue),
          clientY: 250,
          circleDimensionsPx: circleDimensionsPx,
          dataFromOptician: dataFromOptician,
        },
      });
    } else {
      didMountRef.current = true;
    }
  }, [blindspotPositionValue, circleDimensionsPx]);

  useEffect(() => {
    if (Object.keys(messageContent).length) {
      postMessage(messageContent);
    }
  }, [messageContent, postMessage]);

  return (
    <Flex column centered gap={smallScreen ? '1rem' : '1.5rem'} width='100%'>
      <Flex column centered gap={smallScreen ? null : '0.825rem'} width='100%'>
        {!smallScreen && <Text>{`Drag the icon to change the position of your camera preview.`}</Text>}
        <RangeSlider
          smallScreen={smallScreen}
          type='range'
          min={0}
          max={screenWidthPx - blindSpotThumbnailWidthPx || 500}
          onMouseUp={(e) => sendVideoCoordinates(e)}
          onTouchEnd={(e) => sendVideoCoordinates(e)}
          defaultValue={screenWidthPx / 2 - blindSpotThumbnailWidthPx / 2 || 0}
          video
        />
        {smallScreen && <Text marginTop='0.5rem'>{`Video Position`}</Text>}
      </Flex>
      <Flex column centered gap={smallScreen ? null : '0.825rem'} width='100%'>
        {!smallScreen && <Text>{`Drag the icon or use the buttons to change the position of the dot.`}</Text>}
        <BlindspotControl
          smallScreen={smallScreen}
          blindspotPosition={blindspotPositionValue}
          setBlindspotPosition={setBlindspotPositionValue}
          onAfterChange={(newValue) => setBlindspotPositionValue(newValue)}
          postMessage={postMessage}
          messageContent={messageContent}
        />
      </Flex>
      <Text>{`Patient distance: ${distanceFromScreen.toFixed()}mm`}</Text>
    </Flex>
  );
};

export default DistanceControlBlindspot;
